const ManageProfile = () => {
  return <div>Profile</div>;
};

export default ManageProfile;
